import axios from 'axios';
import {store } from 'components/App/components/UnauthenticatedApp';

/**
 * Fetch an endpoint with the given parameters
 *
 * @export
 * @param {any} endpoint
 * @param {any} config
 * @param {any} token
 * @returns {Promise}
 */
async function getNotifications() {

    // Create default request
    let config = {
        headers: {
            'Accept': 'application/json'
        },
        baseURL: '/api'
    };

    // Retrieve token
    let token = store.getState().authentication.token;

    // Check if we need to do token stuff
    if(token) {

        // Add token to header
        config.headers = Object.assign({}, config.headers, {
            'Authorization': `Bearer ${token.access_token}`
        });

    }

    let fetch = axios.create(config);

    return fetch.get('/notifications');

}

export default getNotifications;